/* src/app/self-enrollment/e-sign/e-sign.component.css */
.enroll {
  padding-bottom: 40px;
  background-image:
    linear-gradient(
      to bottom right,
      #dae5f0,
      white);
}
iframe:focus {
  outline: none;
}
iframe[seamless] {
  display: block;
}
/*# sourceMappingURL=e-sign.component.css.map */
